module.exports = __webpack_public_path__ + "static/img/product-bottom-1-new.6ae49906.png";